import React from "react";
import Head from 'next/head'
import Image from 'next/image'

// components
import MainVisual from "../components/templates/shop/top/mainVisual";
import HowToOrder from "../components/templates/shop/top/HowToOrder";
import Features from "../components/templates/shop/top/Features";
import Reason from "../components/templates/shop/top/Reason";
import HappyReports from "../components/templates/shop/top/HappyReports";
import ItemFeatures from "../components/templates/shop/top/ItemFeatures";
import Partners from "../components/templates/shop/top/Partners";
import MedicalNetBook from "../components/templates/shop/top/MedicalNetBook";
import Teiki from "../components/templates/shop/top/Teiki";
import Support from "../components/templates/shop/top/Support";

export const getServerSideProps = async (context) => ({
  props: {
    layout: {
      spacer: false
    }
  }
})

export default function Home() {
  return (
    <div>
      <Head>
        <title>ミールタイム - 美味しい食事宅配　糖尿病・腎臓病・高血圧・メタボ</title>
        <meta name="description" content="【27万人購入】糖尿病・腎臓病・痛風・脂質異常症・高血圧・ダイエット、多数の数値改善実績。日本一の栄養士オペレーター数50名（医療機関ネットワーク2万か所）" />
      </Head>

      <main>
        <MainVisual/>
        <HowToOrder/>
        <Features/>
        <HowToOrder/>
        <Reason/>
        <HappyReports/>
        <ItemFeatures/>
        <Partners/>
        <Teiki/>
        <MedicalNetBook/>
        <Support/>
      </main>

      <footer>
      </footer>
    </div>
  )
}